import React, { useEffect, useState } from 'react';
import SuperadminLayout from '../../components/SuperadminLayout';
import { bankLabel } from '../../utils/bank';
import { fetchGroupTransfers } from '../../api/transfers';
import './SuperadminTransfersPage.css';

const SuperadminTransfersPage = () => {
  const [rows, setRows] = useState([]);
  const [company, setCompany] = useState('');
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = (companyName = '') => {
    setLoading(true);
    setError('');
    fetchGroupTransfers({ company: companyName })
      .then(setRows)
      .catch(() => setError('Chargement impossible.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const submit = (e) => {
    e.preventDefault();
    setCompany(query);
    load(query);
  };

  return (
    <SuperadminLayout>
      <h2 className="stp-title">Historique des transferts POS</h2>

      <form className="stp-search" onSubmit={submit}>
        <input
          type="text"
          placeholder="Filtrer par nom de company"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button type="submit" disabled={loading}>{loading ? '…' : 'Filtrer'}</button>
        {company && (
          <button type="button" onClick={() => { setQuery(''); setCompany(''); load(); }}>Tout</button>
        )}
      </form>

      {error && <p className="stp-error">{error}</p>}

      <table className="stp-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Company</th>
            <th>POS / Bank</th>
            <th>De</th>
            <th>Vers</th>
            <th>Par</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && !loading && (
            <tr><td colSpan="7" className="stp-empty">Aucun transfert.</td></tr>
          )}
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{new Date(r.created_at).toLocaleString()}</td>
              <td>{r.company_name}</td>
              <td>{bankLabel(r.bank_seq, r.bank_name)}</td>
              <td>{r.from_group_name || '—'}</td>
              <td>{r.to_group_name || '—'}</td>
              <td>{r.moved_by}</td>
              <td>{r.note}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </SuperadminLayout>
  );
};

export default SuperadminTransfersPage;
